import e from "@dialpad/dialtone-tokens/layered/themes/tokens-raincloud-colors.css?inline";
//#region themes/raincloud.js
var t = {
	brand: {
		css: e,
		name: "raincloud"
	},
	material: { name: "iron" }
};
//#endregion
export { t as default };
